import React from 'react'
import { useLocation } from 'react-router-dom'
import config from '../Config'
import { t } from '../i18n'
import { track } from '../Utils/analytics'
import { LogoIcon } from './Logo'

/* Mobile web: always-visible "Otvori u aplikaciji" bar (spec 7.1). "Otvori"
   goes to the smart link with this screen, so an installed app opens the
   same story/topic, otherwise the store does (spec 8). */
export default function AppBar() {
  const location = useLocation()
  const to = `${location.pathname}${location.search}`
  const href = `${config.APP_LINK}?to=${encodeURIComponent(to)}&utm_source=web&utm_medium=open_bar`
  return (
    <div className="app-bar">
      <LogoIcon size={38} className="app-bar-icon" />
      <div className="app-bar-text">
        <strong>{t('appBar.title')}</strong>
        <span>{t('appBar.text')}</span>
      </div>
      <a
        className="btn btn-primary btn-small"
        href={href}
        onClick={() => track('open_in_app_click', { to })}
      >
        {t('appBar.open')}
      </a>
    </div>
  )
}
